import React from "react";
import HighlightBadge from "./HighlightBadge";
import NewComerBadge from "./NewComerBadge";
import TopFiveBadge from "./TopFiveBadge";
import FreeShipping from "./FreeShipping";
import "./Badges.scss";

const Badges = ({ hit, maxBadges }) => {
    if (maxBadges === 0) {
        return;
    }
    const addedDate = hit.added.date;
    const currentDays = new Date();
    const addedDay = new Date(addedDate);
    const timeDifference = currentDays - addedDay;
    const newcomerDays = Math.ceil(timeDifference / (1000 * 3600 * 24));

    return (

        <div className="search-hit__badges">
            {hit.detail_shippingPrices.DE === 0 ? <FreeShipping /> : ''}
            {hit.highlight ? <HighlightBadge />  : ''}
            {(newcomerDays <= 30) ? <NewComerBadge /> : ''}
            {hit.istopfive ? <TopFiveBadge  /> : ''}
        </div>
    );
};

export default Badges;
